module.exports = __webpack_public_path__ + "static/media/complete.949ac2cd.svg";